import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Header from '../../common/Header';
import InteractiveInput from '../../common/InteractiveInput';
import TabBar from '../../common/TabBar';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials } from '../../../reducers/messageSlice';
import { setError } from "../../../reducers/loadingSlice";
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../routing/routeConsts';
import { credentialsDefault } from '../../../consts';
import { storageHelper } from '../../../helpers/storageHelper';
import { authHelper } from '../../../api/authHelper';
import ChatList from '../../common/ChatList';

export default function MessagesPage() {
    const navigate = useNavigate();
    const credentials = useSelector(state => state.message.credentials);
    const dispatch = useDispatch();

    const [number, setNumber] = useState();
    const [pin, setPin] = useState();

    const userHumanId = authHelper.getUserHumanId();

    const numberStr = useMemo(() => (Array.isArray(number) ? number : []).filter(x => x || x === 0).join(""), [number]);
    const pinStr = useMemo(() => (Array.isArray(pin) ? pin : []).filter(x => x || x === 0).join(""), [pin]);

    const canAccessChat = useMemo(() => {
        const hasReportNumber = numberStr.length > 0;
        const hasValidPin = pinStr.length === 5;
        return hasReportNumber && hasValidPin;
    }, [numberStr, pinStr]);

    const validateAndEnterChat = useCallback(() => {
        if (!numberStr.length) {
            dispatch(setError("Report Number is required."));
            return;
        }

        if (pinStr.length !== 5) {
            dispatch(setError("PIN must be 5 digits."));
            return;
        }

        dispatch(setCredentials({ pin: pinStr, number: numberStr }));
        navigate(routes.chat);
    }, [dispatch, navigate, numberStr, pinStr]);

    useEffect(() => {
        const storedCredentials = storageHelper.getMessageCredentials();

        if (!credentials && storedCredentials) {
            dispatch(setCredentials(storedCredentials));
            storageHelper.removeMessageCredentials();
            return;
        }

        setNumber(credentials?.number?.split("") || credentialsDefault);
        setPin(credentials?.pin?.split("") || credentialsDefault);
    }, [credentials, dispatch]);

    return (userHumanId ?
        <>
            <Header title={"Messages"} showLanguage={true} />
            <ChatList humanId={userHumanId} />
            <TabBar />
        </>
        :
        <>
            <Header useLogo={true} showLanguage={true} />
            <div className="container messages-page__container tab-bar-predecessor">
                <div className="text_default text_bold text_block">
                    The Report Number and Pin are required to view messages related to your report. <br/> 
                    You can check for new messages at <a href="https://www.reportit.com/messages" target='_blank' className="link-inline">www.reportit.com/messages</a>
                </div>
                <div className="text_default_gray">Enter a Report Number</div>
                <InteractiveInput
                    inputValue={number}
                    onInputValueChange={value => setNumber(value)}
                    uniquePrefix="number"
                />
                <div className="text_default_gray">Enter a Pin</div>
                <InteractiveInput
                    inputValue={pin}
                    onInputValueChange={value => setPin(value)}
                    isExtensible={false}
                    uniquePrefix="pin"
                    onSubmit={() => validateAndEnterChat()}
                />

                {canAccessChat &&
                    <div
                        className="button text_default"
                        onClick={() => validateAndEnterChat()}>
                        Continue
                    </div>
                }

            </div>
            <TabBar />
        </>
    );
}